import { call, put, takeLatest } from 'redux-saga/effects';

import { fundsSlice } from '!views/Market/Funds/redux';
import { marketStockExchangeSlice } from '!views/Market/StockExchange/_marketStockExchange.slice';
import { handleSagaError } from '»utils/handleSagasError';

import { webAreasServices } from './webAreas.services';

const webAreasWorker = function* ({ payload }) {
  try {
    const { webPage } = payload;

    const webAreasData = yield call(webAreasServices.webAreas, {
      webPage,
    });

    if (webPage === 'QUOTES_MARKET') {
      yield put(marketStockExchangeSlice.actions.webAreasSuccess(webAreasData));
    } else {
      yield put(fundsSlice.actions.webAreasSuccess(webAreasData));
    }
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled) {
      if (payload.webPage === 'QUOTES_MARKET') {
        yield put(marketStockExchangeSlice.actions.webAreasFailure(error));
      } else {
        yield put(fundsSlice.actions.webAreasFailure(error));
      }
    }
  }
};

export const webAreasSagas = function* () {
  yield takeLatest(
    [
      marketStockExchangeSlice.actions.webAreasRequest.type,
      fundsSlice.actions.webAreasRequest.type,
    ],
    webAreasWorker,
  );
};
